<template>
	<div id="app">
		<router-view v-if="isRouterAlive" />
	</div>
</template>

<script>
	export default {
		name: 'App',
		provide() {
			return {
				reload: this.reload

			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		methods: {
			reload() {
				this.isRouterAlive = false;
				this.$nextTick(function() {
					this.isRouterAlive = true;
				})
			}
		}
	}
</script>

<style>
	@import url("//at.alicdn.com/t/font_2426149_q1x0g05h31r.css");

	* {
		box-sizing: border-box;
		margin: 0px;
		padding: 0px;
	}

	.mainPadding {
		margin: 20px;
	}

	.el-button--text {
		font-size: 14px !important;
	}

	.tableFooter {
		width: 100%;
		height: 100px;
		border: 1px solid #EBEEF5;
		vertical-align: bottom;

	}

	.selectAll {
		width: 98px;
		height: 40px;
		background: #7C96F8;
		border: 1px solid #7C96F8;
		color: #FFFFFF;
		margin-top: 30px;
		cursor: pointer;
		transition: all 0.3s;
		float: left;
	}

	.addAll {
		width: auto;
		padding: 0 10px;
		height: 30px;
		background: #7C96F8;
		border: 1px solid #7C96F8;
		color: #FFFFFF;
		border-radius: 3px;
		cursor: pointer;
	}

	.add,
	.del {
		width: 98px;
		height: 40px;
		background: #FFFFFF;
		border: 1px solid #000000;
		opacity: 0.4;
		border-radius: 5px;
		float: right;
		margin-top: 30px;
		margin-right: 10px;
		color: #000000;
		transition: all 0.3s;
		cursor: pointer;
		float: left;
		margin-left: 10px;
	}


	.add:hover,
	.del:hover {
		background: #FFFFFF;
		border: 1px solid #F4AE3A;
		border-radius: 5px;
		color: #F4AE3A;
		transition: all 0.3s;
	}

	.export {
		width: 98px;
		height: 40px;
		background: #FFFFFF;
		box-shadow: 2px 2px 5px 1px rgba(124, 150, 248, 0.95);
		color: #7C96F8;
	}

	.submit {
		width: 91px;
		height: 33px;
		background: #8896F6;
		box-shadow: 3px 2px 7px 1px rgba(0, 0, 0, 0.34);
		border-radius: 5px;
		border: 1px solid #8896F6;
		color: #FFFFFF;
		float: left;
	}

	.picTip {
		display: block;
		height: 16px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.5;
		margin-left: 10px;
	}

	.bullet {
		width: 110px;
		height: 28px;
		background: #7C96F8;
		box-shadow: 2px 2px 7px 0px rgba(0, 0, 0, 0.3);
		border-radius: 5px;
		float: left;
		margin-left: 20px;
		border: 1px solid #7C96F8;
		color: #FFFFFF;
		font-size: 16px;
		font-family: PingFang SC;
	}

	.selectBtn {
		width: 95px;
		height: 28px;
		background: #F4AD3A;
		box-shadow: 2px 2px 7px 0px rgba(0, 0, 0, 0.3);
		border-radius: 5px;
		float: left;
		margin-left: 35px;
		border: #F4AD3A;
		color: #FFFFFF;
		font-size: 16px;
		font-family: PingFang SC;
	}

	.reset {
		width: 91px;
		height: 33px;
		background: #FFFFFF;
		border: 1px solid #000000;
		box-shadow: 3px 4px 6px 0px rgba(0, 0, 0, 0.13);
		border-radius: 3px;
		float: right;
		margin-left: 15px;
	}

	.el-pagination {
		text-align: center;
		margin-top: 40px;
	}

	.el-upload-dragger {
		width: 148px !important;
		height: 148px !important;
		line-height: 0 !important;
	}
.el-upload-dragger i{
	padding-top: 40px;
}
	.uploadTip {
		display: block;
		padding-top: 20px;
		font-size: 10px;
		color: #CCCCCC;
	}

	.el-upload--picture-card img {
		width: 100%;
		height: 100%;
	}

	.clear {
		clear: both;
	}
	.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{
		box-shadow: none;
	}
	.el-card, .el-message,.el-alert,.el-tag{
		border-radius: 0;
	}
	
 .el-table .cell{
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		line-height: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue